import { jsx as _jsx } from "react/jsx-runtime";
const MONDAY_BASE_PATH = process.env.MONDAY_BASE_PATH;
export const getFacebookMetaTags = ({ title, description, pagePath, imagePath = "https://s3.amazonaws.com/general-assets/monday-1200x628.png", imageType = "image/png", imageWidth = "1200", imageHeight = "628" })=>{
    return [
        /*#__PURE__*/ _jsx("meta", {
            property: "og:title",
            content: title
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:type",
            content: "website"
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:url",
            content: `${MONDAY_BASE_PATH}${pagePath}`
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:description",
            content: description
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:site_name",
            content: "monday.com"
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:image",
            content: imagePath
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:image:type",
            content: imageType
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:image:width",
            content: imageWidth
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "og:image:height",
            content: imageHeight
        })
    ];
};
